export default __webpack_public_path__ + "static/media/animation021-04.f0d9d934.svg";